<content>
    <section *ngIf="!showForm" ngClass="{{dragAreaClass}}">
        <div>{{'mantenimientoVersionesEtiquetado.upload.arrastraArchivo' | translate}}</div>
        <a (click)="file.click()">
            {{'mantenimientoVersionesEtiquetado.upload.click' | translate}}
        </a>
        <input type="file"
               #file
               [multiple]="false"
               (change)="onFileChange($event)"
               style="display: none" />
    </section>
    <form *ngIf="showForm" [formGroup]="uploadForm" [ngClass]="{'show-error': showError}">
        <div class="entry-2">
            <label>{{'mantenimientoVersionesEtiquetado.upload.archivo' | translate}}</label>
            <input type="text" formControlName="refArchivo" readonly>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button [ngClass]="showForm ? 'secondary' : 'primary'" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button *ngIf="showForm" (click)="save()">{{'mantenimientoVersionesEtiquetado.upload.subir' | translate}}</button>
</footer>
<app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
</app-toast>